<template>
  <b-modal
    id="basicAlertModal"
    v-model="isShowModal"
    hide-footer
    hide-header
    no-close-on-backdrop
    :size="size"
    class="basic-modal-alert"
  >
    <div class="modalContents">
      <header class="basicModalHeader">
        <h6 class="basicModalTitle">{{ title }}</h6>
        <button class="basicModalBtnClose" @click="handClose">
          <img
            src="../../assets/svg/close.svg"
            alt=""
            height="14px"
            width="14px"
          />
        </button>
      </header>
      <div class="modalContent" id="basicModalText">
        <div class="modalContentAlert">
          <slot />
        </div>
        <div class="modalButton" v-if="btnSubmitText">
          <MainButton :btnText="btnSubmitText" @click="handleSubmit" />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import MainButton from "../button/MainButton.vue";

export default {
  name: "basicAlertModal",
  props: {
    size: {
      type: String,
      default: "huge",
    },
    title: {
      type: String,
      default: "알림",
    },
    isShowModal: Boolean,
    btnSubmitText: String,
    handleSubmit: Function,
  },
  data() {
    return {};
  },
  watch: {
    itemSelected(newVal) {
      console.log("ItemSelected:", newVal);
    },
  },
  methods: {
    handClose() {
      this.$emit("close-modal");
    },
  },
  components: { MainButton },
};
</script>

<style scoped lang="scss">
.modalContents {
  .basicModalHeader {
    background-color: #26336a;
    display: flex;
    justify-content: space-between;
    height: 48px;
    align-items: center;
    padding-left: 24px;
    padding-right: 10px;
    margin: -1rem;

    .basicModalTitle {
      color: #fff;
      font-size: 20px;
    }

    .basicModalBtnClose {
      height: 32px;
      width: 32px;
      padding: 0px;
      cursor: pointer;
      border-radius: 50%;
      border: 0px;
      background-color: transparent;
    }
  }

  .modalContent {
    margin: 5rem 6rem;
  }
}

.modalContentAlert {
  font-size: 2.7rem;
}

.modalButton {
  margin-top: 5rem;
  text-align: center;
  .main-button {
    display: inline-block;
  }
}
</style>
